'use strict';



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/lib/registered-extensions.js
// module id = 591
// module chunks = 0